import React from "react";
import { mobilePieLabels } from "../../utils/mobilePieLabels";

export default function MobilePieLabels() {
  return (
    <>
      <div className="mt-20 lg:hidden text-right text-xs w-[326px]">
        <span className="font-bold block text-lg">Tax</span>
        2% on buy/sell
        <br />
        1% LP
        <br />
        1% Marketing
      </div>

      {mobilePieLabels.map((item) => (
        <div
          key={item.id}
          className={`flex flex-col relative justify-center my-3
          ${item.isGreen ? "text-[#80FF00] text-left" : "text-white text-right"}
          w-[326px] h-16 `}
        >
          <div className="absolute my-auto top-0 bottom-0 h-fit ">
            <item.Bg />
          </div>
          <div
            className="space-y-1.5"
            style={{ transform: `translateY(${item.level}px)` }}
          >
            <div className="text-sm font-bold">{item.title}</div>
            <div>
              {item.description && !item.isGreen && (
                <div className={`text-[10px] inline-block mx-2`}>
                  {item.description}
                </div>
              )}
              <div className={`text-xs inline-block`}>{item.percentage}</div>
              {item.description && item.isGreen && (
                <div className={`text-[10px] inline-block mx-2`}>
                  {item.description}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      <div className="text-[10px] w-[326px] mb-20">
        Presale (Pink sale)
        <br />
        No private sale
        <br />
        No max wallet
        <br />
        No max tx
        <br />
        Supply: 10,000,000
      </div>
    </>
  );
}
